export default __webpack_public_path__ + "static/media/event-2.c38e8f2d.jpg";